// Client-side mirror of backend password_policy.py. The server stays
// authoritative — this exists only to drive the live checklist + strength bar.
import zxcvbn from "zxcvbn";

export const PW_MIN = 12;
export const PW_MAX = 64;
const SPECIALS = "!@#$%^&*()-_=+[]{};:'\",.<>/?\\|`~";

export function classChecks(pw) {
  pw = pw || "";
  return {
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    digit: /[0-9]/.test(pw),
    special: [...pw].some((c) => SPECIALS.includes(c)),
    length: pw.length >= PW_MIN && pw.length <= PW_MAX,
  };
}

export function contextViolation(pw, { email = "", name = "" } = {}) {
  const l = (pw || "").toLowerCase();
  if (!l) return null;
  const local = (email.split("@")[0] || "").toLowerCase();
  if (local.length >= 3 && l.includes(local)) return "your email";
  for (const part of (name || "").toLowerCase().split(/\s+/)) {
    if (part.length >= 3 && l.includes(part)) return "your name";
  }
  if (l.includes("opticswap")) return '"opticswap"';
  return null;
}

export function scorePassword(pw, userInputs = []) {
  if (!pw) return { score: 0, feedback: {}, crackTime: "" };
  const r = zxcvbn(pw, userInputs.filter(Boolean));
  return {
    score: r.score,
    feedback: r.feedback || {},
    crackTime: r.crack_times_display?.offline_slow_hashing_1e4_per_second || "",
  };
}

// Have I Been Pwned k-anonymity from the browser: only the first 5 SHA-1 chars
// are transmitted. Requires a secure context (https) for crypto.subtle — preview
// and production both qualify. Degrades to false on any failure.
export async function checkBreach(pw) {
  try {
    if (!pw || !window.crypto?.subtle) return false;
    const buf = await window.crypto.subtle.digest("SHA-1", new TextEncoder().encode(pw));
    const hash = [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("").toUpperCase();
    const prefix = hash.slice(0, 5);
    const suffix = hash.slice(5);
    const res = await fetch(`https://api.pwnedpasswords.com/range/${prefix}`, {
      headers: { "Add-Padding": "true" },
    });
    if (!res.ok) return false;
    const text = await res.text();
    return text.split("\n").some((line) => {
      const [h, count] = line.trim().split(":");
      return h === suffix && parseInt(count, 10) > 0;
    });
  } catch {
    return false;
  }
}
